import script from "./ThreasholdHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreasholdHistory.vue?vue&type=script&setup=true&lang=ts"

import "./ThreasholdHistory.vue?vue&type=style&index=0&id=49422082&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49422082"]])

export default __exports__